import apiEndPoins from "../../utils/apiEndPoints";
import { apiCall } from "../../utils/httpClient";

const getSourcingManagerList = async (params) => {
    const data = await apiCall("post", apiEndPoins.SOURCINGMANAGER, params);
    return data;
};

const getSourcingManagerDetails = async (params) => {
    const data = await apiCall("post", apiEndPoins.SOURCINGMANAGERDETAILS, params);
    return data;
};

const companyService = {
    getSourcingManagerList,
    getSourcingManagerDetails
};

export default companyService;